import ApiService from "@/service/api.service";
export default {
  getStudents() {
    return ApiService.get("index");
  },
  
  getindex() {
    return ApiService.get("/index/index");
  },
  tagBanner() {
    return ApiService.post("/index/tagBanner");
  },
  tagNav() {
    return ApiService.get("/index/tagNav");
  },
  tagLink() {
    return ApiService.get("/index/tagLink");
  },
  tagCatlist(params) {
    return ApiService.get("/category/tagCatlist",params);
  },

  
  tagList(params) {
    return ApiService.get("/category/tagList",params);
  },

  xiangqing(params) {
    return ApiService.get("/show/index",params);
  },
  
}